import {Injectable} from '@angular/core';
import {ConfiguratorUserUiPreferenceService, UserUiPreference, UserUiPreferenceUpdateDto} from '@tj/tj-dmp-lib-api';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

import {
    getDefaultColumnOrder,
    getDefaultVisibleColumnKeys,
    resolveCampaignColumnLayout
} from './campaign-columns.config';

export interface CampaignListColumnLayout {
    visibleColumnKeys: string[];
    orderedColumnKeys: string[];
}

@Injectable({
    providedIn: 'root'
})
export class CampaignListPreferenceService {

    constructor(private readonly configuratorUserUiPreferenceService: ConfiguratorUserUiPreferenceService) {
    }

    load(tenant: string, partner?: string): Observable<CampaignListColumnLayout> {
        return this.configuratorUserUiPreferenceService
            .getCampaignListPreferenceUsingGET(tenant, partner)
            .pipe(
                map((preference) => resolveCampaignColumnLayout(
                    preference?.visibleColumns,
                    preference?.columnOrder
                ))
            );
    }

    save(tenant: string, partner: string | undefined, layout: CampaignListColumnLayout): Observable<UserUiPreference> {
        const body: UserUiPreferenceUpdateDto = {
            visibleColumns: layout.visibleColumnKeys,
            columnOrder: layout.orderedColumnKeys
        };
        return this.configuratorUserUiPreferenceService.saveCampaignListPreferenceUsingPUT(tenant, body, partner);
    }

    getDefaultLayout(): CampaignListColumnLayout {
        return resolveCampaignColumnLayout(getDefaultVisibleColumnKeys(), getDefaultColumnOrder());
    }
}
